
// Mock data for damage analysis
export const damageAnalysisData = {
  totalOverview: {
    totalDamageOrders: 474,
    uniqueDamagedProducts: 234
  },
  damageReasons: [
    { name: "Kapot of beschadigd bij transport", value: 131, percentage: 27.64 },
    { name: "Product vergeten te leveren", value: 82, percentage: 17.30 },
    { name: "Kleurprobleem", value: 53, percentage: 11.18 },
    { name: "Retour of creditaanvraag", value: 35, percentage: 7.38 },
    { name: "Overige melding", value: 173, percentage: 36.48 }
  ],
  supplierAnalysis: [
    { name: "Luijten-VVZ BV", value: 431, percentage: 90.93 },
    { name: "Delta Paints BV", value: 40, percentage: 8.44 },
    { name: "Overige leveranciers", value: 3, percentage: 0.63 }
  ],
  brandAnalysis: [
    { name: "Sigma", value: 118, percentage: 24.89 },
    { name: "Progold", value: 83, percentage: 17.51 },
    { name: "Caparol", value: 32, percentage: 6.75 },
    { name: "Flocx", value: 18, percentage: 3.80 },
    { name: "Sudwest", value: 17, percentage: 3.59 },
    { name: "Overige", value: 206, percentage: 43.46 }
  ],
  thematicClustering: [
    { name: "Kapot of beschadigd bij transport", value: 131, percentage: 27.64 },
    { name: "Product vergeten te leveren", value: 82, percentage: 17.30 },
    { name: "Kleurprobleem", value: 53, percentage: 11.18 },
    { name: "Verkeerde levering", value: 63, percentage: 13.29 },
    { name: "Retour of creditaanvraag", value: 35, percentage: 7.38 },
    { name: "Overige", value: 110, percentage: 23.21 }
  ],
  sigmaVsCaparol: {
    sigma: [
      { reason: "Kleurprobleem", percentage: 18.6, value: 22 },
      { reason: "Beschadigd", percentage: 23.7, value: 28 },
      { reason: "Vergeten", percentage: 9.3, value: 11 },
      { reason: "Verkeerde levering", percentage: 10.3, value: 12 },
      { reason: "Overige", percentage: 38.1, value: 45 }
    ],
    caparol: [
      { reason: "Kleurprobleem", percentage: 28.1, value: 9 },
      { reason: "Beschadigd", percentage: 50.0, value: 16 },
      { reason: "Vergeten", percentage: 15.6, value: 5 },
      { reason: "Verkeerde levering", percentage: 0.1, value: 0 },
      { reason: "Overige", percentage: 6.2, value: 2 }
    ]
  }
};
